import {FormModel} from './form.model.abstract';
import {ValidatorFn} from '@angular/forms';

/**
 * Simple date field.
 * @inheritDoc
 */
export class FormModelDate extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'date';

  /**
   * @inheritDoc
   */
  constructor(id: string, validators: ValidatorFn[] = [], unit: string = null, value: any = null, info: boolean = true) {
    super(id, validators, unit, value, info);
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelDate {
    // @ts-ignore
    return new this.constructor(this.id, this.validators, this.unit, this.value, this.info);
  }
}
